import { ToastContainer } from 'react-toastify';
import { HashRouter as Router } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import RootContainer from "src/containers/root";
import "./App.css";
import * as ServiceWorkerRegistration from "./serviceWorkerRegistration";
import "bootstrap/dist/js/bootstrap";
import 'react-calendar/dist/Calendar.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import "./custom-bootstrap.scss";
import { makeStyles } from '@mui/styles';


function App() {
  const classes = useStyles();
  return (
    <div className="App">
      <div className={classes.portraitMode}>
        <Router>
          <ToastContainer />
          <RootContainer />
        </Router>
      </div>
      <div className={classes.landscapeMode}>
        <h1>Hey, flip your phone to portrait mode please!</h1>
      </div>
    </div >
  );
}

const useStyles = makeStyles({
  portraitMode: {
    display: "none",
    "@media  screen and (min-height: 450px)": {
      height: "100%",
      width: "100%",
      display: "block",
    },
  },
  landscapeMode: {
    display: "none",
    "@media  screen and (max-height: 450px)": {
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
});

ServiceWorkerRegistration.unregister();

export default App;
